<template>
  <div class="maintenance-page">
    <div class="maintenance-panel">
      <img src="/img/logo-symbol.png" alt="PRO" class="maintenance-logo">
      <div>
        <div class="maintenance-kicker">Maintenance Mode</div>
        <h1>Modtools are currently unavailable</h1>
        <p>The page is being worked on and will refresh automatically when maintenance mode ends.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>

<style lang="scss" scoped>
.maintenance-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #151b21;
  color: #f3f6f8;
}

.maintenance-panel {
  display: grid;
  grid-template-columns: auto minmax(0, 560px);
  gap: 24px;
  align-items: center;
  padding: 28px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(20, 27, 34, 0.96);
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.28);
}

.maintenance-logo {
  width: 72px;
  height: 72px;
}

.maintenance-kicker {
  color: #f3c4aa;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}

h1 {
  margin: 5px 0 10px;
  font-size: 1.75rem;
  line-height: 1.2;
}

p {
  margin: 0;
  color: rgba(243, 246, 248, 0.72);
}

@media (max-width: 575px) {
  .maintenance-panel {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .maintenance-logo {
    margin: 0 auto;
  }
}
</style>
